import { render, staticRenderFns } from "./Layout1x3.vue?vue&type=template&id=a9fb855c&scoped=true&"
import script from "./Layout1x3.vue?vue&type=script&lang=js&"
export * from "./Layout1x3.vue?vue&type=script&lang=js&"
import style0 from "./Layout1x3.vue?vue&type=style&index=0&id=a9fb855c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fb855c",
  null
  
)

export default component.exports